import * as R from 'ramda';

import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export const renameBy = (
  obj: object,
  modifier: (val: string) => string,
): object =>
  Object.entries(obj).reduce(
    (acc, [key, value]) => ({ ...acc, [modifier(key)]: value }),
    {},
  );

export default function inventoryReducer(
  state = initialState.inventory,
  action,
) {
  switch (action.type) {
    case actionTypes.GET_INVENTORY_CATEGORIES_SUCCESS: {
      return {
        ...state,
        data: action.data.data,
        columns: action.data.columns,
      };
    }
    case actionTypes.GET_INVENTORY_ASSETS_SUCCESS: {
      const updatedData = action.data.data.map(item => {
        const dataWithoutAttributes = R.omit(['attributes'], item);
        const updatedAttributes = renameBy(item.attributes, key =>
          R.concat('attributes.', key),
        );

        return {
          ...dataWithoutAttributes,
          ...updatedAttributes,
        };
      });

      return {
        ...state,
        data: updatedData,
        columns: action.data.columns,
        categories: {
          inventoryCategory: action.data.parentCategoryId,
          inventoryCategoryTree: state.categories.inventoryCategoryTree,
          inventoryPortalPath: state.categories.inventoryPortalPath,
        },
      };
    }
    case actionTypes.ROOT_INVENTORY_ASSET_DELETION_SUCCESS: {
      const updatedData = state.data.filter(asset => asset.id !== action.data);
      return {
        ...state,
        data: updatedData,
      };
    }
    case actionTypes.GET_INVENTORY_ASSETS_FILTER_SUCCESS: {
      const { data, columns } = action.data;
      const updatedData = data.map(item => {
        const dataWithoutAttributes = R.omit(['attributes'], item);
        const updatedAttributes = renameBy(item.attributes, key =>
          R.concat('attributes.', key),
        );

        return {
          ...dataWithoutAttributes,
          ...updatedAttributes,
        };
      });

      return {
        ...state,
        data: updatedData,
        columns,
        categories: state.categories,
      };
    }
    default: {
      return state;
    }
  }
}
